import { EpimsBaseEntityDto } from './epim-base.dto';
export class OwnershipTypeDto extends EpimsBaseEntityDto {

    OwnershipTypeId: string;

    OwnershipTypeName: string;   

}